import { render, staticRenderFns } from "./UserProp.vue?vue&type=template&id=99672728&scoped=true"
import script from "./UserProp.vue?vue&type=script&lang=js"
export * from "./UserProp.vue?vue&type=script&lang=js"
import style0 from "./UserProp.vue?vue&type=style&index=0&id=99672728&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99672728",
  null
  
)

export default component.exports